<sona-favicon [url]="target()?.url" />
<div class="tw-flex tw-flex-col">
    @if (target(); as safeTarget) {
        <a
            class="link tw-font-medium"
            [class.disabled]="disabled()"
            [routerLink]="disabled() ? null : [ '/domains', safeTarget.id ]"
            (click)="!disabled() && $event.stopPropagation()"
        >{{ safeTarget.name }}</a>
        <div class="tw-text-muted-foreground tw-text-sm">
            <ng-content>
                <a
                    class="link"
                    [class.disabled]="disabled()"
                    [href]="disabled() ? null : safeTarget.url"
                    target="_blank"
                    (click)="!disabled() && $event.stopPropagation()"
                >{{ safeTarget.url }}</a>
            </ng-content>
        </div>
    } @else {
        <span class="placeholder mb-1" style="width: 7rem"></span>
        <span class="placeholder" style="width: 10rem"></span>
    }
</div>